var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 17,
    viewBox: "0 0 78 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5C3.01665 5.19823 4.56155 6.48808 5.73373 7.45737C7.57895 8.98321 10.6512 8.69639 12.5305 7.21273L15.4424 4.91387C17.144 3.57052 19.606 3.82721 20.9939 5.49267L25.0417 10.3501C26.762 12.4144 29.9878 12.2291 31.4604 9.98143L35.6804 3.54045C36.9397 1.61832 39.5559 1.14998 41.4038 2.51585L46.8089 6.5109C48.3664 7.66209 50.5249 7.53207 51.9329 6.20224L54.3673 3.90309C56.3801 2.00217 59.6688 2.67149 60.7784 5.20787L64.0559 12.6992C64.8767 14.5753 66.9819 15.5285 68.9333 14.9076L76.5 12.5",
    stroke: "#288F58",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarIcon);
export default __webpack_public_path__ + "static/media/barIcon.896e64d58850f2dd41248cac5c2c10a2.svg";
export { ForwardRef as ReactComponent };